<style>
  input[type="text"],
  input[type="password"],
  input[type="email"],
  input[type="number"],
  input[type="date"],
  textarea,
  select,
  .text-field {
    font-family: SenRegular;
    font-size: 20px;
    background-color: inherit;
    border: 0;
    border-bottom: 1px gray solid;
    height: 45px;
    border-radius: 0;
    width: 100%;
    padding: 5px 0;
    box-sizing: border-box;
    outline: none;
    color: white;
  }
  input[type="text"].dark {
    color: black;
    border: 1px white solid;
    /* border-radius: 45px; */
    background-color: rgba(255, 255, 255, 0.6);
  }
  input[type="text"].dark::placeholder {
    color: #555;
  }
  input[type="text"].text-no-line,
  input[type="password"].text-no-line,
  input[type="email"].text-no-line,
  input[type="number"].text-no-line,
  input[type="date"].text-no-line,
  textarea.text-no-line,
  select.text-no-line {
    border-bottom: none;
  }
  textarea {
    height: auto;
    min-height: 100px;
    border-bottom: 1px gray solid;
    /* border-radius: 7px; */
  }
  .text-field {
    padding: 10px 10px 3px 10px;
  }
  .text-field-country {
    padding: 10px;
    /* border-bottom: 1px gray solid; */
  }

  .tabs {
    margin: 10px 0;
  }

  .new-link-box {
    margin: 10px 0;
    padding: 6px 10px;
    border: 1px #0000 solid;
  }
  .selected {
    background-color: rgba(255, 255, 255, 0.6);
    border: 1px white solid;
    /* box-shadow: 0 0 10px rgba(255,255,255,0.7); */
    color: black;
  }

  .margin {
    margin: 5px 0;
  }
  .label-margin {
    margin: 30px 10px;
  }
  .label {
    margin: 10px 0;
  }
  .images {
    position: relative;
    text-align: center;
    color: white;
    min-height: 200px;
    border: 1px white dashed;
  }
  img {
    object-fit: cover;
    width: 100%;
  }
  .images-text {
    text-align: center;
    font-family: Sen;
    font-size: 24px;
    min-height: 400px;
    line-height: 400px;
    align-content: center;
    justify-content: center;
  }

  .car-cont {
    display: grid;
  }
  .remove-image {
    grid-column: 1;
    margin: 30px 0 30px 10px;
  }
  .add-another-image {
    grid-column: 2;
    text-align: right;
    margin: 30px 10px 30px 0;
  }
  button.trans {
    font-size: 16px;
  }
  .car-pic-cont {
    max-height: 500px;
  }
  .car-pic {
    width: 100%;
    height: 100%;
  }
  .chars-left {
    font-size: 16px;
    margin: 0 10px 0 10px;
    color: gray;
  }

  .heading {
    text-align: center;
    /* text-decoration: underline; */
    border-bottom: 1px gray solid;
    margin: 30px 40px 0 40px;
    padding: 20px;
    font-size: 25px;
  }
  .item {
    display: grid;
    grid-template-columns: 40px auto;
    color: white;
    margin: 10px 40px 0 40px;
    padding: 10px 0;
  }
  .check {
    grid-column: 1;
    text-align: center;
  }
  .text {
    grid-column: 2;
  }
  .categories-selected {
    background-color: rgba(255, 255, 255, 0.5);
    color: black;
  }
  .range {
    display: grid;
    grid-template-columns: auto 80px;
    align-items: center;
  }
  .range-slider {
    grid-column: 1;
  }
  .range-text {
    grid-column: 2;
  }
</style>

<Auth bind:this="{auth}"></Auth>

<Dialog
  show="{showStartCalendar}"
  title="Pick Start Date"
  height="{440}"
  buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }"
  on:close="{ () => showStartCalendar = false }"
  on:done="{ dateDoneHelper }"
>
  <Calendar bind:date="{parsedStartDate}"></Calendar>
</Dialog>

<Dialog
  show="{showStartTime}"
  title="Pick Start Time"
  height="{450}"
  buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }"
  on:close="{ () => showStartTime = false }"
  on:done="{ timeDoneHelper }"
>
  <TimePicker bind:time="{parsedStartTime}"></TimePicker>
</Dialog>

<Dialog
  show="{showEndCalendar}"
  title="Pick End Date"
  height="{440}"
  buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }"
  on:close="{ () => showEndCalendar = false }"
  on:done="{ dateDoneHelper }"
>
  <Calendar bind:date="{parsedEndDate}"></Calendar>
</Dialog>

<Dialog
  show="{showEndTime}"
  title="Pick End Time"
  height="{450}"
  buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }"
  on:close="{ () => showEndTime = false }"
  on:done="{ timeDoneHelper }"
>
  <TimePicker bind:time="{parsedEndTime}"></TimePicker>
</Dialog>

<Dialog
  show="{showCats}"
  title="Categories"
  height="100%"
  buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }"
  on:close="{ () => showCats = false }"
  on:done="{catsDone}"
>
  <div class="small center">Max 3 can be selected</div>

  {#each interests as item, index} {#if item.h == 0}
  <div class="heading">{item.t}</div>
  {/if} {#if item.h == 1}
  <div
    class="item { item.s == 1 ? 'categories-selected' : '' }"
    on:click="{ () => itemHelper(index) }"
  >
    <div class="check">
      {#if item.s == 1}
      <i class="icon-check"></i>
      {/if}
    </div>
    <div class="text">{item.t}</div>
  </div>
  {/if} {/each}
</Dialog>

<Dialog
  show="{addLink}"
  title="Social Links"
  height="{500}"
  buttons="{[{text: 'Cancel', callback: 'cancel', disabled: false, }]}"
  on:cancel="{ () => addLink = false }"
>
  <SocialLinksSelect on:selected="{addSocialLink}"></SocialLinksSelect>
</Dialog>

<Dialog
  show="{selectCountryShow}"
  title="Select Country"
  height="{400}"
  buttons="{ [ {text: 'Cancel', callback: 'cancel', disabled: false, } ] }"
  on:cancel="{ () => addLink = false }"
>
</Dialog>

<Dialog
  show="{editPhotos ? true : false }"
  title=""
  height="100%"
  buttons="{ [ {text: 'Cancel', callback: 'cancel', disabled: false}, {text: 'Save', callback: 'save', disabled: false}, ] }"
  on:cancel="{ cancelPhotos }"
  on:save="{ savePhotos }"
>
  <Photos
    bind:this="{bindPhotos}"
    bind:show="{editPhotos}"
    bind:photos="{photos}"
    bind:photosToDelete="{photosToDelete}"
    bind:event="{form}"
  ></Photos>
</Dialog>

<Header back="{true}" buttons="{ [  ] }" on:back="{ () => pop() }"
  >{title}</Header
>
<div class="has-header"></div>

{#if photos[0].p != ""}

<div on:click="{ () => editPhotos = true }">
  <Image src="{photos[0].p}" style="object-fit: cover; width: 100%"></Image>
</div>

{:else}

<div class="images-text" on:click="{ () => editPhotos = true }">
  + Add Images
</div>

{/if}

<!-- <div class="tabs">
  <PillTabs theme="dark" disabled="{true}" bind:selected="{form.type}" tabs="{ [ {name: 'Public', selected: true}, {name: 'Private', selected: false } ] }"></PillTabs>
</div> -->

<Group title="Event Name / Venue" required="{true}">
  <input
    type="text"
    bind:value="{form.ename}"
    placeholder="event name"
    on:keyup="{ () => changed = true }"
  />
</Group>

<Group>
  <div class="label">Price<span class="required"> *</span></div>
  <div class="range">
    <div class="range-slider">
      <RangeSlider
        id=""
        min="{0}"
        max="{50}"
        step="{5}"
        bind:values="{form.price}"
        springValues="{ { stiffness: 0.25, damping: 0.9 } }"
        on:change="{ () => changed = true }"
      ></RangeSlider>
    </div>
    <div class="range-text">
      {#if form.price[0] == 0} free {:else} ${form.price[0]} {/if}
    </div>
  </div>

  <!-- <div> -->
  <!-- old -->
  <!-- <input type="text" bind:value="{form.price}" placeholder="price (ie: $5 cover, $3 popcorn)" on:keyup="{ () => changed = true }"> -->
  <!-- </div> -->
</Group>

<Group>
  <div class="label">Start Date and Time<span class="required"> *</span></div>
  <div class="text-field">
    <DateTimeInput
      datetime="{form.start}"
      on:showCalendar="{ () => showStartCalendar = true }"
      on:showTime="{ () => showStartTime = true }"
    ></DateTimeInput>
  </div>

  <div class="label">End Date and Time<span class="required"> *</span></div>
  <div class="text-field">
    <DateTimeInput
      datetime="{form.end}"
      on:showCalendar="{ () => showEndCalendar = true }"
      on:showTime="{ () => showEndTime = true }"
    ></DateTimeInput>
  </div>
</Group>

<Group
  title="Categories"
  required="{true}"
  icon="pencil3"
  on:click="{ () => showCats = true }"
>
  {cats}
</Group>

<Group>
  <div class="label">Select Country<span class="required"> *</span></div>
  <div class="text-field-country">
    <SelectCountry></SelectCountry>
  </div>
</Group>

<Group>
  {#if form.country == "us"}
  <UnitedStates
    bind:item="{form.address}"
    on:changed="{ () => {addressChanged = true; changed = true} }"
  ></UnitedStates>
  {/if}
</Group>

<Group>
  <div class="label">Phone</div>
  <div>
    <input
      type="text"
      bind:value="{form.phone}"
      placeholder="phone"
      on:keyup="{ () => changed = true }"
    />
  </div>
</Group>

<Group>
  <div class="label">Details<span class="required"> *</span></div>
  <div>
    <textarea bind:value="{form.details}" on:keyup="{detailsCheck}"></textarea>
  </div>
  <div class="chars-left">{detailsLen} Characters Left</div>
</Group>

<Group>
  <div class="label label-margin">Social Links</div>
  <SocialLinks bind:links="{form.links}"></SocialLinks>
  <div class="margin center">
    <button class="trans" on:click="{ () => addLink = true }">
      + Add Link
    </button>
  </div>
</Group>

<Group>
  <div class="label label-margin">Friends Invited - coming soon</div>
  {#each form.invitedFriends as item, index }
  <FriendsInput
    oid="{item.oid}"
    name="{item.name}"
    index="{index}"
    on:delete="{deleteInvitedFriend}"
  ></FriendsInput>
  {/each}
  <div class="margin center">
    <div>
      <button
        class="trans"
        on:click="{ () => showInviteFriends = true }"
        disabled
      >
        + Invite Friends
      </button>
    </div>
  </div>
  <!-- is a dialog that is shown when showInviteFriends = true -->
  <FriendsPicker
    bind:show="{showInviteFriends}"
    bind:friends="{form.invitedFriends}"
    allFriends="{allFriends}"
  ></FriendsPicker>
</Group>

<div class="label-margin">
  {#if changed}
  <button on:click="{saveEvent}">Save Event</button>
  {:else}
  <button disabled="{true}">Save Event</button>
  {/if}
</div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>
  import { push, pop, replace, location, link } from "svelte-spa-router";
  export let params = {};

  import Auth from "../interfaces/Auth.svelte";
  let auth;

  /*
  manually added
  https://github.com/vadimkorr/svelte-carousel/blob/7c0fa877d04688824c72975def7985539370cb60/src/components/Carousel/Carousel.svelte
  */
  import Carousel from "../../node-overriden/svelte-carousel";
  import RangeSlider from "svelte-range-slider-pips";

  import Words from "../helpers/Words.js";
  import tinterests from "../helpers/InterestCategories.js";

  import Header from "../components/Header.svelte";
  import ActionBar from "../components/ActionBar.svelte";
  import PillTabs from "../components/PillTabs.svelte";
  import Calendar from "../components/Calendar.svelte";
  import TimePicker from "../components/TimePicker.svelte";
  import Dialog from "../components/DialogSlide.svelte";
  import DateTimeInput from "../components/DateTimeInput.svelte";
  import LinkInput from "../components/LinkInput.svelte";
  import SocialLinks from "../components/SocialLinks.svelte";
  import SocialLinksSelect from "../components/SocialLinksSelect.svelte";
  import FriendsInput from "../components/FriendsInput.svelte";
  import FriendsPicker from "../components/FriendsPicker.svelte";
  import Image from "../components/Image.svelte";
  import Group from "../components/Group.svelte";
  import Photos from "../components/EditEvent/Photos.svelte";
  let bindPhotos;

  import SelectCountry from "../components/address/SelectCountry.svelte";
  import UnitedStates from "../components/address/UnitedStates.svelte";
  // see components/address/UnitedStates.svelte to dynamically add address forms

  import UnitedStatesProc from "../addresses/UnitedStates.js";
  let countryProc = {
    us: UnitedStatesProc,
    // "id": Indonesia,
  };

  import DateTime from "../helpers/DateTime.js";
  import Normalize from "../helpers/Normalize.js";
  import Validate from "../helpers/Validate.js";
  import Xss from "../helpers/Xss.js";

  let title = "Create New Event";

  let showStartCalendar = false;
  let showStartTime = false;
  let showEndCalendar = false;
  let showEndTime = false;
  let showCats = false;
  let addLink = false;
  let newLink = { icon: "", link: "" };
  let addLinkButtons = [
    { text: "Cancel", callback: "close", disabled: false },
    { text: "Done", callback: "done", disabled: true },
  ];

  let changed = false;
  // a nice flag for the back end to have
  let addressChanged = false;
  let selectCountryShow = false;
  let showInviteFriends = false;

  let imageIndex;

  let parsedStartDate = "";
  let parsedStartTime = "";
  let parsedEndDate = "";
  let parsedEndTime = "";

  let cats = "None Selected";
  let interests = [];

  let detailsLen = 1000;

  let allFriends = [];

  let editPhotos = false;
  let photosToDelete = [];
  let photos = [
    { c: "nop", i: "", p: "" },
    { c: "nop", i: "", p: "" },
    { c: "nop", i: "", p: "" },
    { c: "nop", i: "", p: "" },
    { c: "nop", i: "", p: "" },
    { c: "nop", i: "", p: "" },
  ];

  let form = {
    photoIds: ["", "", "", "", "", ""],
    type: "Public",
    ename: "",
    start: "",
    end: "",
    categories: [],
    country: "",
    address: {},
    phone: "",
    price: [0],
    details: "",
    links: [],
    invitedFriends: [],
    cohosts: [],
  };

  $: {
    if (form.start || form.end) getDate();
  }

  import { onMount } from "svelte";
  onMount(async () => {
    interests;
    interests = tinterests.convert();

    if (params.eid != "new") {
      title = "Edit Event";

      try {
        Validate.uid(params.eid);
      } catch (error) {
        console.log("edit event loading error:", error);
      }

      // need to filter any incoming data, because the server can not filter xss
      // in encrypted data.  the clients will filter before saving, but if there
      // is a nefarious client out there, they might be able to inject xss,
      // bypassing any client side filtering

      // auth.message("Loading");

      let uid = JSON.parse(localStorage.getItem("store"))["uid"];

      try {
        // we need to load the event from the server

        // we use a separate "editEventLoad" api call instead of eventInfo
        // because we want to make sure the user has permission to edit
        // the event, which eventInfo does not do
        // console.log("loading event from server");
        let event = await auth.post("editEventLoad", {
          uid: uid,
          eid: params.eid,
        });
        form = JSON.parse(event);

        console.log("form:", form);

        form.price = [form.price];

        form.invitedFriends = [];
        photos = [
          { c: "nop", i: "", p: "" },
          { c: "nop", i: "", p: "" },
          { c: "nop", i: "", p: "" },
          { c: "nop", i: "", p: "" },
          { c: "nop", i: "", p: "" },
          { c: "nop", i: "", p: "" },
        ];
        for (let i in form.photoIds) {
          if (form.photoIds[i] != "") {
            photos[i].p = `/ei/cookie/csrf/${form.eid}/${form.photoIds[i]}`;
            photos[i].i = form.photoIds[i];
          }
        }

        console.log("photos:", photos);

        cats = "";
        for (let i in interests) {
          if (form.categories.includes(interests[i].i) == true) {
            interests[i].s = true;
            cats += cats == "" ? interests[i].t : ", " + interests[i].t;
          }
        }
        if (cats == "") cats = "None Selected";
      } catch (error) {
        console.log("edit event loading error:", error);
      }
    } else {
      // we have a new form - init a few things
      form.start = DateTime.tomorrow() + " 09:00:00";
      form.end = DateTime.tomorrow() + " 10:00:00";

      // form.ename = "The One And Only Houdini";
      // form.start = "2022-10-31 09:00:00";
      // form.end = "2022-10-31 10:00:00";
      form.country = "us";
      // form.address = countryProc[form.country].empty();
      // form.address.address = "1234 Main St";
      // form.address.address2 = "";
      // form.address.city = "Los Angeles";
      // form.address.state = "CA";
      // form.address.zip = "90000";
      // form.phone = "";
      // form.price = "$5 shots, $10 cover";
      // form.details = "Come down and get some magic show fairy dust sprinkled all over you at the Blue Room.";
      // form.links = [ {icon: 'website', link: 'asdf.com'} ];
      // changed = true;
      // console.log("form:", form);
    }
  });

  function removeImageHelper() {
    photos.splice(imageIndex, 1);
    form.photoIds.splice(imageIndex, 1);
    form = form;
    changed = true;
  }

  function getDate(start, end) {
    parsedStartDate = form.start.split(" ")[0];
    parsedStartTime = form.start.split(" ")[1];
    parsedEndDate = form.end.split(" ")[0];
    parsedEndTime = form.end.split(" ")[1];
  }

  function dateDoneHelper() {
    let tdate = form.start.split(" ");
    tdate[0] = parsedStartDate;
    form.start = tdate.join(" ");

    tdate = form.end.split(" ");
    tdate[0] = parsedEndDate;
    form.end = tdate.join(" ");

    // parse start date to see if it's higher than end date
    let tsdate = new Date(form.start).getTime();
    let tedate = new Date(form.end).getTime();
    if (tedate < tsdate) {
      form.end = form.start;
    }

    showStartCalendar = false;
    showEndCalendar = false;
    changed = true;
  }

  function timeDoneHelper() {
    let tdate = form.start.split(" ");
    tdate[1] = parsedStartTime;
    form.start = tdate.join(" ");

    tdate = form.end.split(" ");
    tdate[1] = parsedEndTime;
    form.end = tdate.join(" ");

    // parse start time to see if it's higher than end time
    let tsdate = new Date(form.start).getTime();
    let tedate = new Date(form.end).getTime();
    if (tedate < tsdate) {
      form.end = form.start;
    }

    showStartTime = false;
    showEndTime = false;
    changed = true;
  }

  function deleteLink(e) {
    form.links.splice(e.detail.index, 1);
    form = form;
    changed = true;
  }

  function newLinkChanged() {
    if (newLink.link == "") {
      addLinkButtons[1].disabled = true;
    } else {
      addLinkButtons[1].disabled = false;
    }
    changed = true;
  }

  function deleteInvitedFriend(e) {
    // deselect friends from allFriends (used in FriendPicker.svelte)
    for (let i in allFriends) {
      if (allFriends[i].oid == invitedFriends[e.detail.index].oid) {
        allFriends[i].selected = false;
        break;
      }
    }
    form.invitedFriends.splice(e.detail.index, 1);
    form = form;
    changed = true;
  }

  function addSocialLink(e) {
    form.links.push(e.detail.link);
    form = form;
    addLink = false;
    changed = true;
  }

  function typeSelected(e) {
    changed = true;
  }

  function saveEvent() {
    // each one of these requires a different way of saving, validation, etc...
    if (form.type == "Public") savePublicEvent();
    if (form.type == "Private") savePrivateEvent();
  }

  async function savePublicEvent() {
    console.log("form:", form);

    if (changed == false) return;

    auth.message("Saving...");

    let validated = false;

    // validate
    try {
      if (params.eid != "new") {
        // eid can be validated with uid()
        Validate.uid(params.eid);
      }
      // console.log("eid validated");

      Validate.isArrayFilled(photos, "images");
      // console.log("images validated");

      Validate.isArrayFilled(form.photoIds, "photoIds");
      // console.log("photoIds validated");

      Validate.contains(form.type, ["Public", "Private"], "Event Type");
      // console.log("event type validated");

      Validate.name(form.ename);
      // console.log("name validated");

      Validate.datetime(form.start);
      // console.log("start validated");

      Validate.datetime(form.end);
      // console.log("end validated");

      Validate.isArrayFilled(form.categories, "categories");
      // console.log("categories validated");

      Validate.country(form.country, ["us", "id"]);
      // console.log("country validated");

      // validate each address property
      let objs = Object.keys(form.address);

      // we don't need to validate address 2 - it can be empty
      // this needs to be made address system wide
      objs.splice(objs.indexOf("address2"), 1);

      for (let i in objs) {
        Validate.string(form.address[objs[i]], objs[i]);
        // console.log(objs[i] + " validated");
      }

      if (form.phone != "") {
        Validate.phone(form.phone);
        // console.log("phone validated");
      }

      console.log(
        "form.price[0]:",
        form.price[0],
        "typeof form.price[0]",
        typeof form.price[0]
      );
      Validate.integer(form.price[0], "price");
      // console.log("price validated");

      Validate.string(form.details, "details");
      // console.log("details validated");

      for (let i in form.links) {
        if (form.links[i].link == "") form.links.splice(i, 1);
      }

      validated = true;
    } catch (error) {
      console.log("validation error:", error);
      auth.errorDialog("Not Quite Done...", error);
    }

    if (validated == true) {
      // xss filter
      let photosSave = [];
      for (let i in photos) {
        if (photos[i].c == "new") {
          photosSave.push(Xss.filter(photos[i]));
        }
      }

      for (let i in form.photoIds) {
        form.photoIds[i] = Xss.filter(form.photoIds[i]);
      }
      form.type = Xss.filter(form.type);
      form.ename = Xss.filter(form.ename);
      form.start = Xss.filter(form.start);
      form.end = Xss.filter(form.end);
      form.country = Xss.filter(form.country);

      for (let i in form.categories) {
        form.categories[i] = Xss.filter(form.categories[i]);
      }

      let objs = Object.keys(form.address);
      for (let i in objs) {
        form.address[objs[i]] = Xss.filter(form.address[objs[i]]);
      }

      if (form.phone != "") {
        form.phone = Xss.filter(form.phone);
      }
      form.price[0] = Xss.filter(form.price[0]);
      form.details = Xss.filter(form.details);

      for (let i in form.links) {
        form.links[i].icon = Xss.filter(form.links[i].icon);
        form.links[i].link = Xss.filter(form.links[i].link);
      }

      // normalize

      // console.log("address:", form.address);

      form.ename = Normalize.ucwords(form.ename);

      // we'll need to include this in an export const from the proper
      // address handler array, including phone and price
      form.address.address = Normalize.address(form.address.address);
      // form.address.address2 = Normalize.ucwords(form.address.address2);
      form.address.city = Normalize.ucwords(form.address.city);
      form.address.state = form.address.state.toUpperCase();
      if (form.phone != "") {
        form.phone = Normalize.phone(form.phone);
      }

      // extract time
      let splitDateTime = DateTime.splitDate(form.start);
      let splitDateTimeEnd = DateTime.splitDate(form.end);
      let startHour = parseInt(splitDateTime.hour);
      let endHour = parseInt(splitDateTimeEnd.hour);

      // build index of event for searching

      // included are ename, country, address, city, state, zip
      // price, description, social links, day (ie: thursday), month (ie: April)

      // price goes in it's own little search index

      // event name
      let index = [...Words.filter(form.ename)];

      // start day - eventually, if someone creates an event that ranges over days
      // we'll create a range of days for it
      index = [...index, ...[DateTime.day(splitDateTime)]];
      index = [...index, ...[DateTime.month(splitDateTime)]];

      // index country
      index = [...index, ...countryProc[form.country].searchIndex()];

      // index address
      let text =
        form.address.address +
        " " +
        form.address.city +
        " " +
        form.address.state +
        " " +
        form.address.zip;
      index = [...index, ...Words.address(text)];

      // details
      index = [...index, ...Words.filter(form.details)];

      // currency
      let currency = countryProc[form.country].currency();

      // social media
      for (let i in form.links) {
        index.push(form.links[i].link.toLowerCase());
      }

      index = Words.removeDuplicates(index);

      console.log("index:", JSON.stringify(index));

      // return;

      // because we're sending binary image files, we'll use a new FormData
      // to build our request instead of JSON

      // let body = new FormData();
      // body.append("eid", params.eid);
      // body.append("addressChanged", addressChanged == true ? 1 : 0);
      // body.append("type", form.type);
      // body.append("ename", form.ename);
      // body.append("start", form.start);
      // body.append("end", form.end);
      // body.append("country", form.country);
      // body.append("address", JSON.stringify(form.address));
      // body.append("phone", form.phone);
      // body.append("price", form.price);
      // body.append("details", form.details);
      // body.append("links", JSON.stringify(form.links));
      // body.append("index", JSON.stringify(index));
      // // body.append("invitedFriends", JSON.stringify(form.invitedFriends));
      // // body.append("cohosts", JSON.stringify(form.cohosts));
      // body.append("photoIds", JSON.stringify(form.photoIds));

      // for (let i in photos) {
      //   // make sure this is a new image - we don't want to transfer anything else
      //   if (photos[i].includes("data:image/jpeg;base64,") == true) {
      //     let out = photos[i].slice("data:image/jpeg;base64,".length);
      //     out = atob(out);
      //     let buf = new Blob([out], {type: "image/jpeg"});
      //     body.append(i+".image", buf, "image."+i);
      //   }
      // }

      let body = {
        eid: params.eid,
        addressChanged: addressChanged == true ? 1 : 0,
        type: form.type,
        ename: form.ename,
        start: form.start,
        end: form.end,
        startHour: startHour,
        endHour: endHour,
        categories: form.categories,
        country: form.country,
        address: form.address,
        phone: form.phone,
        price: form.price[0],
        currency: currency,
        details: form.details,
        links: form.links,
        index: index,
        // invitedFriends: form.invitedFriends,
        // cohosts: form.cohosts,
        photoIds: form.photoIds,
        photos: photosSave,
        photosToDelete: photosToDelete,
      };

      console.log("post body:", body);

      try {
        // let res = await auth.postBinary("editEvent", body);
        let res = await auth.post("editEvent", body);

        if (res == "+") {
          // photos = [];
          replace("/events/popular");
        }
      } catch (error) {
        console.log("error:", error);
      }
    }
  }

  async function savePrivateEvent() {}

  function savePhotos() {
    bindPhotos.save();
    changed = true;
  }

  function cancelPhotos() {
    editPhotos = false;
  }

  function detailsCheck() {
    changed = true;
    detailsLen = 1000 - form.details.length;
  }

  function itemHelper(index) {
    let count = 0;
    for (let i in interests) {
      if (interests[i].s == true) {
        count++;
      }
    }

    if (count < 3) {
      interests[index].s = !interests[index].s;
    } else {
      interests[index].s = false;
    }
  }

  function catsDone() {
    form.categories = [];

    cats = "";
    for (let i in interests) {
      if (interests[i].s == true) {
        form.categories.push(interests[i].i);
        cats += cats == "" ? interests[i].t : ", " + interests[i].t;
      }
    }

    if (cats == "") cats = "None Selected";

    showCats = false;
    changed = true;
  }
</script>
